/**
 * SSH Tüneller erişim kontrolü — GEÇİCİ (ADR #023).
 *
 * Roller henüz backend'de tanımlı değil (Hems/Cni ekibi sonra ekleyecek). O zamana
 * kadar SSH tunnel sayfası sadece **süper admin** hesabına açık → e-posta allowlist.
 * Backend tarafı da aynı kontrolü yapar (cni-ssh-api `SUPERADMIN_EMAILS`).
 *
 * İleride backend gerçek roller verince burası role-bazlı kontrole çevrilecek.
 */
// SSH Tüneller şimdilik SADECE STG'de aktif (dev mock + müşteriye açık olduğu için).
// stg gerçek süper admin e-postası: "admin@oklidis.com.tr".
// Dev mock e-postası "admin@oklidis.com" KASITEN listede DEĞİL → dev'de menü hiç görünmez.
// İleride dev'den mock kalkınca eklenir.
const SSH_SUPERADMIN_EMAILS = ["admin@oklidis.com.tr"] as const

// Lokal geliştirme istisnası: mock login e-postası "admin@oklidis.com" (.tr YOK),
// allowlist'te olmadığı için sayfa lokalde de gizli kalırdı. import.meta.env.DEV
// SADECE `npm run dev`'de true; HER `vite build` (deploy edilen apm-dev/stg image
// dahil) false → canlıda yine `.tr` şartı geçerli, müşteriye açık dev'de görünmez.
const SSH_DEV_PREVIEW_EMAILS = ["admin@oklidis.com"] as const

export function canAccessSshDevices(email: string | null | undefined): boolean {
  if (!email) {
    return false
  }
  const normalized = email.trim().toLowerCase()
  if (SSH_SUPERADMIN_EMAILS.includes(normalized as never)) {
    return true
  }
  if (import.meta.env.DEV && SSH_DEV_PREVIEW_EMAILS.includes(normalized as never)) {
    return true
  }
  return false
}
